;(() => {
  // Content Tabs Functionality
  const setActiveContent = (section, activeId) => {
    const contentEls = section.querySelectorAll('.twn-content-tabs__content')

    contentEls.forEach((el) => {
      el.classList.remove('twn-content-tabs__content--active')
      el.classList.remove('animate')
    })

    const activeContent = section.querySelector(`[data-content-tab-id="${activeId}"].twn-content-tabs__content`)

    if (activeContent) {
      activeContent.classList.add('twn-content-tabs__content--active')
      setTimeout(() => {
        activeContent.classList.add('animate')
      }, 100)
    }
  }

  const toggleTab = (section) => {
    const tabs = section.querySelectorAll('.twn-content-tabs__tab')

    tabs.forEach((tab) => {
      const currentId = tab.dataset.contentTabId

      tab.addEventListener('click', (event) => {
        if (!event.currentTarget.classList.contains('twn-content-tabs__tab--active')) {
          tabs.forEach((el) => {
            el.classList.remove('twn-content-tabs__tab--active')
            const icon = el.querySelector('.icon')
            if (icon) {
              icon.classList.remove('icon-minus')
              icon.classList.add('icon-plus')
              const svg = icon.querySelector('svg')
              svg.innerHTML = `
                <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                  <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
                </foreignObject>
                <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
                <path d="M20.9111 15L20.9111 25" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <path d="M15.9048 20H25.9175" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <defs>
                  <clipPath id="bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                    <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                  </clipPath>
                </defs>
              `
            }
          })

          tab.classList.add('twn-content-tabs__tab--active')
          const icon = tab.querySelector('.icon')
          if (icon) {
            icon.classList.remove('icon-plus')
            icon.classList.add('icon-minus')
            const svg = icon.querySelector('svg')
            svg.innerHTML = `
              <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
              </foreignObject>
              <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
              <path d="M15.9048 20H25.9175" stroke="#858585" stroke-width="3" stroke-linecap="round"/>
              <defs>
                <clipPath id="bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                  <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                </clipPath>
              </defs>
            `
          }

          setActiveContent(section, currentId)
        }
      })

      tab.addEventListener('keydown', (event) => {
        if (!event.currentTarget.classList.contains('twn-content-tabs__tab--active') && event.key === 'Enter') {
          tabs.forEach((el) => {
            el.classList.remove('twn-content-tabs__tab--active')
            const icon = el.querySelector('.icon')
            if (icon) {
              icon.classList.remove('icon-minus')
              icon.classList.add('icon-plus')
              const svg = icon.querySelector('svg')
              svg.innerHTML = `
                <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                  <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
                </foreignObject>
                <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
                <path d="M20.9111 15L20.9111 25" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <path d="M15.9048 20H25.9175" stroke="#252525" stroke-width="3" stroke-linecap="round"/>
                <defs>
                  <clipPath id="bgblur_0_334_${el.dataset.contentTabId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                    <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                  </clipPath>
                </defs>
              `
            }
          })

          tab.classList.add('twn-content-tabs__tab--active')
          const icon = tab.querySelector('.icon')
          if (icon) {
            icon.classList.remove('icon-plus')
            icon.classList.add('icon-minus')
            const svg = icon.querySelector('svg')
            svg.innerHTML = `
              <foreignObject x="-3.11426" y="-4" width="48.0508" height="48">
                <div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(2px);clip-path:url(#bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path);height:100%;width:100%"></div>
              </foreignObject>
              <ellipse data-figma-bg-blur-radius="4" cx="20.9111" cy="20" rx="20.0254" ry="20" fill="white"/>
              <path d="M15.9048 20H25.9175" stroke="#858585" stroke-width="3" stroke-linecap="round"/>
              <defs>
                <clipPath id="bgblur_0_334_${currentId.replace('#content-tab-', '')}_clip_path" transform="translate(3.11426 4)">
                  <ellipse cx="20.9111" cy="20" rx="20.0254" ry="20"/>
                </clipPath>
              </defs>
            `
          }

          setActiveContent(section, currentId)
        }
      })
    })
  }

  const setWidthForAfter = (section) => {
    const wrapper = section.querySelector('.twn-content-tabs__tabs-wrapper')
    if (!wrapper) return

    const setVariable = (el) => {
      el.style.setProperty('--wrapper-border-width', `0px`)
      const elScrollWidth = el.scrollWidth
      el.style.setProperty('--wrapper-border-width', `${elScrollWidth}px`)
    }

    setVariable(wrapper)

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setVariable(entry.target)
      })
    })
    resizeObserver.observe(wrapper)
  }

  // twn-slideshow Functionality
  const playVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper

      if (sliderSwiper.slides[sliderSwiper.previousIndex]) {
        const videoPrev = sliderSwiper.slides[sliderSwiper.previousIndex].querySelector('.twn-slideshow__video video')
        if (videoPrev) {
          videoPrev.pause()
        }
      }

      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[sliderSwiper.activeIndex].querySelector('.twn-slideshow__video video')
        if (videoActive) {
          videoActive.play()
        }
      }
    }
  }

  const stopVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper

      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[sliderSwiper.activeIndex].querySelector('.twn-slideshow__video video')
        if (videoActive) {
          videoActive.pause()
        }
      }
    }
  }

  const initSlider = (section) => {
    if (!section || !section.classList.contains('section-twn-slideshow')) return

    const box = section.querySelector('.twn-slideshow')

    if (box) {
      const swiperParams = {
        speed: 800,
        autoHeight: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
      }

      const changeColorScheme = (swiper) => {
        const activeIndex = swiper.activeIndex
        const activeSlide = swiper.slides[activeIndex]
        const colorScheme = activeSlide.dataset.colorScheme
        const exploreBtn = box.querySelector('.twn-slideshow__explore-btn')

        const changeItems = [
          swiper.navigation.nextEl,
          swiper.navigation.prevEl,
          swiper.pagination.el,
          ...(exploreBtn ? [exploreBtn] : []),
        ]

        changeItems.forEach((item) => {
          if (item) {
            let classNames = item.getAttribute('class')
            classNames = classNames.replace(/color-background-\d+/g, '')
            item.setAttribute('class', classNames)
            item.classList.add(colorScheme)
          }
        })
      }

      if (box.getAttribute('data-autoplay') === 'true') {
        swiperParams.autoplay = {
          disableOnInteraction: true,
        }
      }

      if (box.getAttribute('data-loop') === 'true') {
        swiperParams.loop = true
        swiperParams.loopPreventsSliding = false
      }

      if (box.getAttribute('data-pagination') === 'true') {
        const paginationEl = box.querySelector('.swiper-pagination')

        swiperParams.pagination = {
          el: paginationEl,
          type: 'bullets',
          clickable: true,
        }
      }

      if (box.getAttribute('data-parallax') === 'true') {
        swiperParams.parallax = true
      }

      if (box.getAttribute('data-animation-type') === 'fade') {
        swiperParams.effect = 'fade'
      } else {
        swiperParams.effect = 'slide'
      }

      if (box.getAttribute('data-full-width') === 'false') {
        swiperParams.breakpoints = {
          990: {
            spaceBetween: 16,
          },
        }
      }

      if (box.getAttribute('data-layout') === 'overlay') {
        const sliderOverlay = box.querySelector('.twn-slideshow__swiper--overlay')

        if (sliderOverlay) {
          const swiperOverlay = new Swiper(sliderOverlay, swiperParams)

          changeColorScheme(swiperOverlay)
          swiperOverlay.on('slideChange', function () {
            changeColorScheme(swiperOverlay)
            playVideo(sliderOverlay)
          })
        }
      } else if (box.getAttribute('data-layout') === 'split_screen') {
        const sliderText = box.querySelector('.twn-slideshow__swiper--text')
        const sliderMedia = box.querySelector('.twn-slideshow__swiper--media')

        if (box.getAttribute('data-full-width') === 'false') {
          swiperParams.spaceBetween = 8
          swiperParams.breakpoints = {
            990: {
              spaceBetween: 16,
            },
          }
        }

        if (sliderText && sliderMedia) {
          const swiperText = new Swiper(sliderText, swiperParams)

          const swiperMedia = new Swiper(sliderMedia, {
            ...swiperParams,
            autoplay: false,
            pagination: false,
            navigation: false,
            parallax: false,
          })

          swiperText.controller.control = swiperMedia
          swiperMedia.controller.control = swiperText

          changeColorScheme(swiperText)
          swiperText.on('slideChange', function () {
            changeColorScheme(swiperText)
          })
          swiperMedia.on('slideChange', function () {
            playVideo(sliderMedia)
          })
        }
      }
    }
  }

  const initScrollToExplore = (section) => {
    if (!section || !section.classList.contains('section-twn-slideshow')) return

    const scrollBtn = section.querySelector('.twn-slideshow__explore-btn')
    if (!scrollBtn) return

    const nextSection = section.nextElementSibling

    scrollBtn.addEventListener('click', () => {
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' })
        return
      }

      section.scrollIntoView({ behavior: 'smooth' })
    })

    scrollBtn.addEventListener('keydown', (event) => {
      if (nextSection && event.key === 'Enter') {
        nextSection.scrollIntoView({ behavior: 'smooth' })
        return
      }

      section.scrollIntoView({ behavior: 'smooth' })
    })
  }

  const initSection = (section) => {
    if (!section) return

    // Initialize Content Tabs
    if (section.classList.contains('twn-content-tabs-section')) {
      toggleTab(section)
      setWidthForAfter(section)
    }

    // Initialize twn-slideshow
    if (section.classList.contains('section-twn-slideshow')) {
      initSlider(section)
      initScrollToExplore(section)

      const box = section.querySelector('.twn-slideshow')
      let slider
      if (box && box.getAttribute('data-layout') === 'overlay') {
        slider = section.querySelector('.twn-slideshow__swiper')
      } else if (box && box.getAttribute('data-layout') === 'split_screen') {
        slider = section.querySelector('.twn-slideshow__swiper--media')
      }

      if (slider) {
        const sectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              playVideo(slider)
              if (slider.swiper && slider.getAttribute('data-autoplay') === 'true') {
                slider.swiper.autoplay.resume()
              }
            } else {
              stopVideo(slider)
              if (slider.swiper && slider.getAttribute('data-autoplay') === 'true') {
                slider.swiper.autoplay.pause()
              }
            }
          })
        })
        sectionObserver.observe(section)
      }
    }
  }

  // Initialize both sections
  initSection(document.currentScript.parentElement)

  // Handle dynamic section loading
  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target)
  })
})()
